import {Component, Input} from '@angular/core';
import { IndicatorIcon } from '../enums/indicator-icon.enum';
import { IndicatorStyle } from '../enums/indicator-style.enum';
@Component({
    selector:    'verification-action-indidicator',
    templateUrl: './verification-action-indicator.component.html',
    styleUrls:   ['./verification-action-indicator.component.scss']
})
export class VerificationActionIndicatorComponent {
    @Input() statusStyle: IndicatorStyle;
    @Input() statusIcon: IndicatorIcon;
    @Input() statusLabel: string;
}